<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        巡查记录详情
      </div>
    </div>

    <!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->

    <el-form
      ref="form"
      v-model="form"
      :model="form"
      label-width="80px"
      class="mt20"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row> </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点编号">
              <el-input v-model="form.pointNum"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查点名称">
              <el-input v-model="form.pointName"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="巡查点位置">
              <el-input v-model="form.pointAddr"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="是否异常">
              <el-radio disabled v-model="form.pointError" :label="1"
                >异常</el-radio
              >
              <el-radio disabled v-model="form.pointError" :label="0"
                >正常</el-radio
              >
              <!-- <el-radio v-model="form.pointError" :label="2">当场整改</el-radio> -->
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="巡查结果描述">
              <el-input
                type="textarea"
                v-model="form.pointErrorDesc"
              ></el-input>
            </el-form-item>
            <el-form-item
              label-width="160px"
              prop="correctiveMeasures"
              v-show="[2,4,5].includes(form.pointStates)"
              label="整改意见"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <el-input
                type="textarea"
                v-model="form.correctiveMeasures"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <!-- <el-form-item label-width="160px" prop="" label="巡查点设备">
              <el-input v-model="form.pointBasic"></el-input>
            </el-form-item> -->
            <el-form-item label-width="160px" prop="" label="NFC编号">
              <el-input v-model="form.nfcNum"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="上报人员">
              <el-input v-model="form.commitName"></el-input>
            </el-form-item>
            <el-form-item label-width="160px" prop="" label="创建时间">
              <el-input v-model="form.createTime"></el-input>
            </el-form-item>
            <el-form-item
              v-if="$route.query.view"
              label-width="160px"
              prop=""
              label="状态"
            >
              <el-button type="info" size="mini">{{
                $map.checkstates[form.pointStates]
              }}</el-button>
            </el-form-item>
            <el-form-item
              label-width="160px"
              prop="correctionTime"
              label="整改时间"
              v-show="[2,4,5].includes(form.pointStates)"
              :rules="{
                message: '请填写/选择',
                trigger: 'blur',
                required: true,
              }"
            >
              <el-date-picker
                v-model="form.correctionTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>

      <!-- <el-row>
        <el-form-item
          label-width="160px"
          prop=""
          label="现场照片"
          v-for="item in form.imgList"
          :key="item"
        >
          <img class="ml20 mt20" :src="item" alt="" style="" /> </el-form-item
      ></el-row> -->
      <el-row>
        <el-col :span="12">
          <el-form-item
            label-width="160px"
            prop=""
            label="现场照片"
            v-if="form.imgList && form.imgList.length"
          >
            <img
              class="ml20 mt20"
              v-for="item in form.imgList"
              :key="item"
              :src="item"
              alt=""
              style="max-height:390px"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label-width="160px"
            prop=""
            label="整改后照片"
            v-if="form.imgbackList && form.imgbackList.length"
          >
            <img
              class="ml20 mt20"
              v-for="item in form.imgbackList"
              :key="item"
              :src="item"
              alt=""
              style="max-height:390px"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="btn-box flex1 center" style="margin-bottom: 40px">
      <el-button
        type="danger"
        @click="changestatus()"
        v-if="!$route.query.view&&form.pointStates==2"
        v-hasPermi="['relic:relicInspectionRecords:updateStatus']"
        >问题确认</el-button
      >
      <!-- <el-button type="primary" @click="changestatus(1)" v-if="!$route.query.view" v-hasPermi="['relic:relicInspectionRecords:updateStatus']">复核</el-button> -->
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
// import {buildList} from './options'
// import {addCompany, editCompany} from "../../api/company";
// import {getArea} from "../../api/common";
import { getSafeList } from "../../api/safety";

export default {
  data() {
    return {
      id: this.$route.query.id || "",
      form: {},
      radio: "",
      CheckedKeys: [],
      props: {
        label: "111",
        children: "zo11nes",
      },
      list2: [],

      list: [],
    };
  },
  created() {
    if (this.id) {
      this.$get(`/relic/relicInspectionRecords/selectInfoById/${this.id}`).then(
        (res) => {
          console.log(res, 11111111111);
          this.form = res.data;

          if (this.form.logImageUrl) {
            //整改前
            this.form.imgList = this.form.logImageUrl.split(";");
          }
          if (this.form.logImageUrlOut) {
            //整改后
            this.form.imgbackList = this.form.logImageUrlOut.split(";");
          }
        }
      );
    }
    this.getList();
  },
  mounted() {},

  methods: {
    handleCheckChange(v, b) {
      // console.log(v.id);
      // console.log(v)
      this.CheckedKeys = this.$refs.tree1.getCheckedKeys();
      this.$refs.tree1.getCheckedKeys();
    },
    addtime() {
      if (this.form.get_rate.length < 2) {
        this.form.get_rate.push({
          m_start_time: "",
          m_end_time: "",
          m_rate: "",
        });
      } else {
        this.form.get_rate.splice(1);
      }
    },
    getList() {
      this.loading = true;
    },
    //通过不通过

    changestatus(stae) {
      // var pointStates = stae ? 3 : 4;
      var pointStates = 4;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$put("/relic/relicInspectionRecords/updateStatus", {
            id: this.form.id,
            pointStates,
            correctiveMeasures:this.form.correctiveMeasures,
            correctionTime:this.form.correctionTime
          }).then((res) => {
            // this.$message.success("操作成功");
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 700,
            });
            this.$router.back();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.container-list {
  padding: 0 20px;
}
.tree {
  font-size: 18px;
}
</style>
